<!-- src\components\dispositivos\ModalOperacionInfo.vue -->
<template>
  <div v-if="visible" class="fixed inset-0 z-70 bg-gray-50 flex flex-col w-full h-screen overflow-hidden">

    <div class="bg-white px-6 py-3 border-b border-gray-200 shadow-sm flex-shrink-0">
      <div class="flex items-center justify-between">
        <div class="flex items-center space-x-4">
          <h2 class="text-lg font-semibold text-gray-800">Evaluación de Operatividad</h2>
          <span v-if="equipos.length > 0" class="bg-blue-50 text-blue-700 text-xs font-bold px-3 py-1 rounded-md border border-blue-100">
            {{ equipos.length }} equipos en local
          </span>
        </div>

        <div class="flex items-center space-x-4">
          <button @click="cerrarModal" class="w-8 h-8 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center transition-colors focus:outline-none focus:ring-2 focus:ring-gray-300" title="Cerrar ventana">
            <svg class="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
            </svg>
          </button>
        </div>
      </div>
    </div>

    <div class="flex-1 overflow-y-auto p-4 sm:p-6 lg:p-8">
      <div class="mx-auto space-y-6">

        <div class="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden">
          <button @click="mostrarNiveles = !mostrarNiveles" class="w-full flex items-center justify-between px-5 py-3 text-sm font-semibold hover:bg-gray-50 transition-colors focus:outline-none">
            <div class="flex items-center gap-2 text-gray-700">
              <svg class="w-5 h-5 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <span>Descriptivo de Niveles de Operatividad</span>
            </div>
            <svg :class="{ 'rotate-180': mostrarNiveles }" class="w-5 h-5 text-gray-400 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
            </svg>
          </button>

          <div v-show="mostrarNiveles" class="p-5 border-t border-gray-100 bg-gray-50/50">
            <div class="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-4">
              <div class="bg-white p-3 rounded border border-gray-100 shadow-sm">
                <div class="flex items-center gap-2 mb-1.5">
                  <div class="w-3.5 h-3.5 rounded-full bg-green-500 shadow-sm"></div>
                  <span class="text-xs font-bold text-gray-800">VERDE</span>
                </div>
                <p class="text-[11px] text-gray-600 leading-tight">Equipos que requieren mantención general, lavado, limpieza de serpentines, filtros</p>
              </div>
              <div class="bg-white p-3 rounded border border-gray-100 shadow-sm relative">
                <div class="flex items-center gap-2 mb-1.5">
                  <div class="w-3.5 h-3.5 rounded-full bg-yellow-400 shadow-sm"></div>
                  <span class="text-xs font-bold text-gray-800">AMARILLO</span>
                </div>
                <p class="text-[11px] text-gray-600 leading-tight">Equipos que requieren no solo mantención si no que remplazo de Ventilador, reparación de motor de impulsión, reemplazo de contactores eléctricos u otros elementos según sea el caso. Las reparaciones duran poco tiempo para dejar operativa el equipo.</p>
              </div>
              <div class="bg-white p-3 rounded border border-gray-100 shadow-sm relative">
                <div class="flex items-center gap-2 mb-1.5">
                  <div class="w-3.5 h-3.5 rounded-full bg-orange-500 shadow-sm"></div>
                  <span class="text-xs font-bold text-gray-800">NARANJA</span>
                </div>
                <p class="text-[11px] text-gray-600 leading-tight">Equipos que requieren no solo lo anterior, si no que reparación al menos 1 circuito de refrigeración, cuyo tiempo de proceso es más alto debido a los pasos que se requieren para dejar operativo el equipo.</p>
              </div>
              <div class="bg-white p-3 rounded border border-gray-100 shadow-sm relative">
                <div class="flex items-center gap-2 mb-1.5">
                  <div class="w-3.5 h-3.5 rounded-full bg-red-600 shadow-sm"></div>
                  <span class="text-xs font-bold text-gray-800">ROJO</span>
                </div>
                <p class="text-[11px] text-red-600 font-medium leading-tight">Equipos que no será posible su reparación, por daño en compresores, serpentines, líneas de refrigeración, falta de control, falta de expansión, daños exteriores de carcazas y refrigerante utilizado en maquina R22.</p>
              </div>
              <div class="bg-white p-3 rounded border border-gray-100 shadow-sm">
                <div class="flex items-center gap-2 mb-1.5">
                  <div class="w-3.5 h-3.5 rounded-full bg-gray-400 shadow-sm"></div>
                  <span class="text-xs font-bold text-gray-800">GRIS</span>
                </div>
                <p class="text-[11px] text-gray-600 leading-tight">Equipos que requieren la reparación de ambos circuitos de refrigeración, ventiladores disipadores, entre otros elementos. cuyo tiempo de proceso es más alto debido los pasos que se requieren para dejar operativa la máquina. (los equipos en esta condición están fuera de servicio)</p>
              </div>
            </div>
          </div>
        </div>

        <div v-if="loading" class="bg-white rounded-lg border border-gray-200 p-12 text-center shadow-sm">
          <div class="inline-block animate-spin rounded-full h-8 w-8 border-4 border-gray-100 border-t-blue-600"></div>
          <p class="mt-4 text-sm text-gray-500 font-medium">Cargando parque de equipos...</p>
        </div>

        <div v-else-if="error" class="bg-white rounded-lg border border-red-200 p-8 text-center shadow-sm">
          <div class="text-red-500 text-sm mb-4 font-medium">{{ error }}</div>
          <button @click="cargarDatos" class="px-5 py-2 bg-white border border-red-200 text-red-600 rounded-lg hover:bg-red-50 transition-colors text-sm font-semibold">
            Reintentar
          </button>
        </div>

        <div v-else-if="equipos.length === 0" class="bg-white rounded-lg border border-gray-200 p-16 text-center text-gray-500 shadow-sm">
          <svg class="w-12 h-12 mx-auto mb-3 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 002-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
          </svg>
          <p class="text-sm font-medium">No hay equipos registrados para mostrar.</p>
        </div>

        <div v-else class="bg-white rounded-lg border border-gray-200 divide-y divide-gray-100 shadow-sm">
          <div v-for="item in equipos" :key="'fila_' + item.id" class="group flex flex-col">

            <div @click="item.expandido = !item.expandido" class="flex items-center p-4 transition-colors cursor-pointer gap-4" :class="[
              item.expandido ? 'bg-gray-50' : 'bg-white',
              !item.expandido && String(item.color_operatividad).toUpperCase() === 'VERDE' ? 'hover:bg-green-100' : '',
              !item.expandido && String(item.color_operatividad).toUpperCase() === 'AMARILLO' ? 'hover:bg-yellow-100' : '',
              !item.expandido && String(item.color_operatividad).toUpperCase() === 'NARANJA' ? 'hover:bg-orange-100' : '',
              !item.expandido && String(item.color_operatividad).toUpperCase() === 'ROJO' ? 'hover:bg-red-100' : '',
              !item.expandido && String(item.color_operatividad).toUpperCase() === 'GRIS' ? 'hover:bg-gray-200' : ''
            ]">

              <div class="flex flex-col items-center justify-center min-w-[64px]">
                <div class="relative w-6 h-6 flex items-center justify-center mb-1.5">
                  <span v-if="String(item.color_operatividad).toUpperCase() === 'AMARILLO'" class="absolute inline-flex h-full w-full rounded-full bg-yellow-400 opacity-75 animate-[ping_2s_cubic-bezier(0,0,0.2,1)_infinite]"></span>
                  <span v-if="String(item.color_operatividad).toUpperCase() === 'NARANJA'" class="absolute inline-flex h-full w-full rounded-full bg-orange-500 opacity-75 animate-[ping_1.5s_cubic-bezier(0,0,0.2,1)_infinite]"></span>
                  <span v-if="String(item.color_operatividad).toUpperCase() === 'ROJO'" class="absolute inline-flex h-full w-full rounded-full bg-red-600 opacity-75 animate-[ping_1s_cubic-bezier(0,0,0.2,1)_infinite]"></span>

                  <div class="relative w-6 h-6 rounded-full shadow-sm border-2 border-white ring-2 ring-gray-100" :class="obtenerClaseColorOperatividad(item.color_operatividad)"></div>
                </div>
                <span class="text-xs font-extrabold text-gray-700">{{ item.porcentaje_operatividad }}%</span>
              </div>

              <div class="w-px h-12 bg-gray-200 hidden sm:block"></div>

              <div class="w-12 h-12 bg-white rounded-lg border border-gray-200 flex items-center justify-center overflow-hidden flex-shrink-0 shadow-sm">
                <img v-if="item.imagenUrl" :src="item.imagenUrl" :alt="item.nombre" class="w-full h-full object-cover" @error="item.imagenUrl = null" />
                <svg v-else class="w-6 h-6 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
              </div>

              <div class="flex-1 min-w-0">
                <h4 class="text-base font-bold text-gray-900 truncate">{{ item.nombre }}</h4>
                <div class="flex items-center text-sm text-gray-500 mt-0.5 gap-2">
                  <span class="font-medium text-gray-600">{{ item.marca }}</span>
                  <span class="w-1 h-1 rounded-full bg-gray-300"></span>
                  <span class="truncate">{{ item.ubicacion }}</span>
                </div>
              </div>

              <div class="flex-shrink-0 pl-4">
                <button class="px-4 py-2 rounded-lg text-sm font-semibold transition-all focus:outline-none focus:ring-2 focus:ring-offset-1" :class="item.expandido ? 'bg-gray-200 text-gray-700 hover:bg-gray-300 focus:ring-gray-300' : 'bg-white border border-gray-300 text-gray-700 hover:border-blue-400 hover:text-blue-600 focus:ring-blue-500 shadow-sm'">
                  {{ item.expandido ? 'Ocultar' : 'Evaluar' }}
                </button>
              </div>
            </div>

            <div v-show="item.expandido" class="p-4 sm:p-6 bg-gray-50/80 border-t border-gray-100">
              <div class="bg-white p-5 sm:p-6 rounded-xl border border-gray-200 shadow-sm max-w-5xl mx-auto">

                <div class="flex flex-col sm:flex-row sm:items-center justify-between mb-5 pb-4 border-b border-gray-100 gap-3">
                  <div>
                    <h5 class="text-base font-bold text-gray-800">Checklist de Evaluación</h5>
                    <p class="text-xs text-gray-500 mt-0.5">Marca los componentes que presentan fallas.</p>
                  </div>
                  <div class="flex items-center gap-2 bg-gray-50 px-3 py-1.5 rounded-lg border border-gray-200">
                    <span class="text-xs font-medium text-gray-600">Proyección actual:</span>
                    <span class="text-sm font-bold" :class="{ 'text-red-600': item.porcentaje_operatividad < 50, 'text-green-600': item.porcentaje_operatividad >= 80, 'text-yellow-600': item.porcentaje_operatividad >= 50 && item.porcentaje_operatividad < 80 }">
                      {{ item.porcentaje_operatividad }}%
                    </span>
                  </div>
                </div>

                <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3 mb-6">
                  <div v-for="(campo, key) in componentesLevantamiento" :key="key" class="flex items-center justify-between p-3 bg-white border border-gray-200 rounded-lg hover:border-blue-300 transition-colors shadow-sm">
                    <span class="text-sm font-medium text-gray-700">{{ campo.label }}</span>
                    <div class="flex items-center gap-4">
                      <label class="flex items-center gap-1.5 cursor-pointer group">
                        <input type="radio" :name="key + '_' + item.id" :value="true" v-model="item[key]" @change="calcularPreview(item)" class="w-4 h-4 text-green-600 border-gray-300 focus:ring-green-500" />
                        <span class="text-xs font-semibold text-gray-500 group-hover:text-green-600 transition-colors">Ok</span>
                      </label>
                      <label class="flex items-center gap-1.5 cursor-pointer group">
                        <input type="radio" :name="key + '_' + item.id" :value="false" v-model="item[key]" @change="calcularPreview(item)" class="w-4 h-4 text-red-600 border-gray-300 focus:ring-red-500" />
                        <span class="text-xs font-semibold text-gray-500 group-hover:text-red-600 transition-colors">Falla</span>
                      </label>
                    </div>
                  </div>
                </div>

                <div class="grid grid-cols-1 lg:grid-cols-3 gap-5 mb-6">
                  <div class="lg:col-span-2">
                    <label class="block text-sm font-bold text-gray-700 mb-2">Observación técnica</label>
                    <textarea v-model="item.observacion" rows="3" class="w-full rounded-lg border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 text-sm p-3 resize-none" placeholder="Ingresa detalles sobre repuestos necesarios, causa raíz de la falla..."></textarea>
                  </div>
                  <div>
                    <label class="block text-sm font-bold text-gray-700 mb-2">Evidencia Fotográfica</label>
                    <div class="border-2 border-dashed border-gray-300 rounded-lg p-4 bg-gray-50 hover:bg-gray-100 transition-colors flex flex-col items-center justify-center h-[98px] relative group">
                      <input type="file" @change="alSeleccionarFoto($event, item)" accept="image/*" class="absolute inset-0 w-full h-full opacity-0 cursor-pointer z-10" title="Subir foto" />
                      <div v-if="!item.fotoPreview" class="text-center">
                        <svg class="mx-auto h-6 w-6 text-gray-400 group-hover:text-blue-500 transition-colors mb-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                        </svg>
                        <span class="text-xs font-medium text-gray-500">Subir imagen</span>
                      </div>
                      <div v-else class="flex flex-col items-center text-green-600">
                        <svg class="h-6 w-6 mb-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                        </svg>
                        <span class="text-xs font-bold">Imagen cargada</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="flex justify-end gap-3 pt-4 border-t border-gray-100">
                  <button @click="item.expandido = false" class="px-5 py-2.5 text-gray-600 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 text-sm font-bold transition-colors focus:outline-none focus:ring-2 focus:ring-gray-200">
                    Cancelar
                  </button>
                  <button @click="guardarEvaluacion(item)" :disabled="item.guardando" class="px-6 py-2.5 text-white bg-blue-600 rounded-lg hover:bg-blue-700 text-sm font-bold flex items-center gap-2 shadow-sm disabled:opacity-50 disabled:cursor-not-allowed transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2">
                    <svg v-if="item.guardando" class="animate-spin h-4 w-4 text-white" fill="none" viewBox="0 0 24 24">
                      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                      <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    {{ item.guardando ? 'Procesando...' : 'Guardar Evaluación' }}
                  </button>
                </div>

              </div>
            </div>

          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import DispositivosService from '@/services/dispositivos/dispositivos.js'
import ImagenDefault from '@/assets/ImagenDefaultDispositivos.png'

export default {
  name: 'ModalOperacionInfo',
  props: {
    visible: { type: Boolean, default: false },
    localId: { type: [Number, String], default: null }
  },
  emits: ['close', 'operatividad-actualizada'],
  data() {
    return {
      mostrarNiveles: false,
      equipos: [],
      detallesLevantamiento: [],
      loading: false,
      error: null,
      componentesLevantamiento: {
        blower_funciona: { label: 'Blower' },
        compresor_1_funciona: { label: 'Compresor 1' },
        ventilador_1_funciona: { label: 'Ventilador 1' },
        compresor_2_funciona: { label: 'Compresor 2' },
        ventilador_2_funciona: { label: 'Ventilador 2' }
      }
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        document.body.style.overflow = 'hidden'
        if (this.localId) this.cargarDatos()
      } else {
        document.body.style.overflow = ''
      }
    },
    localId(newVal) {
      if (newVal && this.visible) this.cargarDatos()
    }
  },
  methods: {
    cerrarModal() {
      this.$emit('close')
    },
    async cargarDatos() {
      try {
        this.loading = true
        this.error = null
        await Promise.all([
          this.cargarDispositivos(),
          this.cargarDetallesLevantamiento()
        ])
        this.asociarDetallesConEquipos()
      } catch (error) {
        this.error = error.message || 'Error cargando datos'
      } finally {
        this.loading = false
      }
    },
    async cargarDispositivos() {
      if (!this.localId) {
        this.equipos = []
        return
      }
      const dispositivos = await DispositivosService.obtenerDispositivosPorLocal(this.localId)
      this.equipos = dispositivos.map(dispositivo => ({
        id: dispositivo.id,
        nombre: dispositivo.nombre_dispositivo,
        marca: dispositivo.marca_dispositivo,
        ubicacion: dispositivo.ubicacion_dispositivo,
        imagenUrl: this.obtenerUrlImagen(dispositivo),

        blower_funciona: null,
        compresor_1_funciona: null,
        ventilador_1_funciona: null,
        compresor_2_funciona: null,
        ventilador_2_funciona: null,
        observacion: '',
        color_operatividad: 'GRIS',
        porcentaje_operatividad: 0,
        detalle_levantamiento_id: null,
        expandido: false,
        archivo_foto: null,
        guardando: false
      }))
    },
    async cargarDetallesLevantamiento() {
      try {
        this.detallesLevantamiento = await DispositivosService.obtenerDetallesLevantamiento()
      } catch (error) {
        this.detallesLevantamiento = []
      }
    },
    asociarDetallesConEquipos() {
      this.equipos.forEach(equipo => {
        const detalle = this.detallesLevantamiento.find(d => d.dispositivo === equipo.id)
        if (detalle) {
          equipo.blower_funciona = detalle.blower_funciona ?? null
          equipo.compresor_1_funciona = detalle.compresor_1_funciona ?? null
          equipo.ventilador_1_funciona = detalle.ventilador_1_funciona ?? null
          equipo.compresor_2_funciona = detalle.compresor_2_funciona ?? null
          equipo.ventilador_2_funciona = detalle.ventilador_2_funciona ?? null
          equipo.observacion = detalle.observacion || ''
          equipo.color_operatividad = detalle.color_operatividad || 'GRIS'
          equipo.porcentaje_operatividad = detalle.porcentaje_operatividad || 0
          equipo.detalle_levantamiento_id = detalle.id
        }
      })
    },
    calcularPreview(equipo) {
      if (equipo.blower_funciona === false) {
        equipo.porcentaje_operatividad = 0
      } else if (equipo.blower_funciona === true) {
        let activos = 0
        if (equipo.compresor_1_funciona) activos++
        if (equipo.ventilador_1_funciona) activos++
        if (equipo.compresor_2_funciona) activos++
        if (equipo.ventilador_2_funciona) activos++
        equipo.porcentaje_operatividad = 20 + (20 * activos)
      }

      const p = equipo.porcentaje_operatividad
      if (p >= 80) equipo.color_operatividad = 'VERDE'
      else if (p >= 60) equipo.color_operatividad = 'AMARILLO'
      else if (p >= 20) equipo.color_operatividad = 'NARANJA'
      else equipo.color_operatividad = 'ROJO'
    },
    alSeleccionarFoto(event, equipo) {
      const file = event.target.files[0]
      if (file) {
        equipo.archivo_foto = file
      }
    },
    async guardarEvaluacion(equipo) {
      try {
        equipo.guardando = true

        const payload = {
          dispositivo: equipo.id,
          blower_funciona: equipo.blower_funciona,
          compresor_1_funciona: equipo.compresor_1_funciona,
          ventilador_1_funciona: equipo.ventilador_1_funciona,
          compresor_2_funciona: equipo.compresor_2_funciona,
          ventilador_2_funciona: equipo.ventilador_2_funciona,
          observacion: equipo.observacion
        }

        let detalleGuardado
        if (equipo.detalle_levantamiento_id) {
          detalleGuardado = await DispositivosService.actualizarDetalleLevantamiento(equipo.detalle_levantamiento_id, payload)
        } else {
          detalleGuardado = await DispositivosService.crearDetalleLevantamiento(payload)
          equipo.detalle_levantamiento_id = detalleGuardado.id
        }

        if (equipo.archivo_foto) {
          const formData = new FormData()
          formData.append('detalle_levantamiento', equipo.detalle_levantamiento_id)
          formData.append('descripcion', 'Foto evidencia frontend')
          formData.append('archivo', equipo.archivo_foto)

          await DispositivosService.subirEvidenciaLevantamiento(formData)
        }

        equipo.expandido = false
        equipo.archivo_foto = null
        await this.cargarDatos()
        this.$emit('operatividad-actualizada');
      } catch (error) {
        console.error("Error guardando la evaluación", error)
      } finally {
        equipo.guardando = false
      }
    },
    obtenerClaseColorOperatividad(color) {
      const clases = {
        'VERDE': 'bg-green-500',
        'AMARILLO': 'bg-yellow-400 text-gray-800',
        'NARANJA': 'bg-orange-500',
        'ROJO': 'bg-red-600',
        'GRIS': 'bg-gray-400'
      }
      return clases[color] || 'bg-gray-400'
    },
    obtenerUrlImagen(dispositivo) {
      if (!dispositivo.media) return ImagenDefault
      if (dispositivo.media.startsWith('http')) return dispositivo.media

      const baseURL = process.env.VUE_APP_API_URL
      const cleanPath = dispositivo.media.startsWith('/') ? dispositivo.media : `/${dispositivo.media}`
      return `${baseURL}${cleanPath}`
    },
    handleEscapeKey(event) {
      if (event.key === 'Escape' && this.visible) this.cerrarModal()
    }
  },
  mounted() {
    document.addEventListener('keydown', this.handleEscapeKey)
  },
  beforeUnmount() {
    document.removeEventListener('keydown', this.handleEscapeKey)
    document.body.style.overflow = ''
  }
}
</script>

<style scoped>
.rotate-180 {
  transform: rotate(180deg);
}
</style>